import { useState } from "react";
import Grid from "@material-ui/core/Grid";

import AddCircleIcon from "@material-ui/icons/AddCircle";
import RemoveCircleOutlinedIcon from "@material-ui/icons/RemoveCircleOutlined";
import AddToListModal from "../../../../../../../Components/FormGenerator/addToListModal";
import {
  Divider,
  Typography,
  Button,
  TextField,
  Select,
  Input,
  Tooltip,
  MenuItem,
} from "@material-ui/core";
import { useDispatch } from "react-redux";
import { Autocomplete } from "@material-ui/lab";
import { TOGGLE_GROWING_LIST_POPUP } from "../../../../../../../Redux/actions";
import { getDropdowns } from "../../HelperFunctions";
import { additionalDropdowns } from "../../HelperFunctions";

const MagicFieldsComponent = (props) => {
  const {
    inputValue,
    handleCustomSubmit,
    rowState,
    cell,
    handleClose: handleClosePopup,
    row,
    table,
  } = props;
  const dispatch = useDispatch();

  const { id, customComponentKey } = cell.column.columnDef;

  const { liveViewType } = table.options.state;

  const { dropdowns, setDropdowns } = rowState;

  const magicDropdown = dropdowns["magic20_fields"];

  const [magicValues, setMagicValues] = useState(inputValue);

  const initialValue = magicDropdown?.filter((el) =>
    Object.keys(inputValue).includes(el.id)
  );
  const [showAddNewModal, setShowAddNewModal] = useState({
    show: false,
    params: {},
  });

  const [magicFieldsValue, setMagicFieldsValue] = useState(initialValue || []);

  // Add new option
  const handleAddNew = (event, type, magic20_id) => {
    event.preventDefault();
    let params = { drop_down: "Magic20", field_name: "name" };
    if (type === "magicAssociates") {
      params = {
        drop_down: "Magic20Associate",
        field_name: "field_name",
        magic20_field_id: magic20_id,
      };
    }
    setShowAddNewModal({ show: true, params: params });

    dispatch({ type: TOGGLE_GROWING_LIST_POPUP, payload: true });
  };

  // After adding new option
  const handleAddNewValue = (newValue, newId) => {
    getDropdowns(liveViewType, row.original.id)
      .then((response) => {
        setDropdowns(
          {
            ...response,
            ...additionalDropdowns,
          } || {}
        );
        if (showAddNewModal.params.drop_down === "Magic20") {
          const toBeAddedElement = response["magic20_fields"].filter(
            (el) => el.magic20_field_id === newId
          );
          setMagicFieldsValue((prev) => {
            return [...prev, ...toBeAddedElement];
          });
          setMagicValues((prev) => {
            return { ...prev, [toBeAddedElement[0]?.id]: [] };
          });
        }
        if (showAddNewModal.params.drop_down === "Magic20Associate") {
          const toBeAddedElement = response["magic20_fields"].filter(
            (el) =>
              el.magic20_field_id === showAddNewModal.params.magic20_field_id
          );
          const tobeAddedKey = toBeAddedElement[0].id;

          const filteredValue = toBeAddedElement[0].magic20_associates.filter(
            (el) => el.value === newValue
          );
          setMagicValues((prev) => {
            const oldObj = { ...prev };
            oldObj[tobeAddedKey] = [
              ...oldObj[tobeAddedKey],
              filteredValue[0]?.id,
            ];
            return oldObj;
          });
          setMagicFieldsValue((prev) => {
            const oldArr = [...prev];
            const toBeChangedIndex = oldArr.findIndex(
              (el) => el.id === tobeAddedKey
            );
            if (toBeChangedIndex !== -1) {
              oldArr[toBeChangedIndex] = toBeAddedElement[0];
            }
            return oldArr;
          });
        }
      })
      .catch((err) => {});
  };

  const handleSubmit = () => {
    handleCustomSubmit(id, magicValues, customComponentKey);
    handleClosePopup();
  };

  return (
    <>
      <div
        style={{
          display: "flex",
          height: "100%",
          flexDirection: "column",
          alignItems: "space-between",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginTop: "0.5rem",
            marginBottom: "1rem",
            width: "100%",
          }}
        >
          <Typography
            variant="h6"
            style={{ fontSize: "16px", fontWeight: "bold" }}
          >
            Terminology Used
          </Typography>
        </div>
        <div style={{ width: "100%", flexGrow: 1 }}>
          <div>
            <Typography
              variant="subtitle2"
              style={{
                fontSize: "12px",
                fontWeight: "bold",
                marginBottom: "0.75rem",
              }}
            >
              Terminology used for Departments/Business units etc.
            </Typography>
            <Autocomplete
              placeholder="Please select terminologies"
              multiple
              id={"autoComplete" + id}
              ListboxProps={{
                style: {
                  fontSize: "12px",
                },
              }}
              options={[
                ...(magicDropdown || []),
                { id: "add_new", value: "+ Add New" },
              ]}
              ChipProps={{
                style: {
                  fontSize: "12px",
                },
              }}
              onChange={(event, newValue) => {
                if (newValue[newValue.length - 1].id === "add_new") {
                  handleAddNew(event, "magic");
                } else {
                  setMagicFieldsValue(newValue);
                  setMagicValues((prev) => {
                    const newObj = {};
                    newValue.forEach((newEl) => {
                      const isValuesExisting = prev[newEl.id]?.length > 0;
                      if (isValuesExisting) {
                        newObj[newEl.id] = prev[newEl.id];
                      } else {
                        newObj[newEl.id] = [];
                      }
                    });
                    return newObj;
                  });
                }
                console.log(event, newValue, "new value");
              }}
              getOptionLabel={(option) => option?.value}
              style={{ width: "100%" }}
              value={magicFieldsValue}
              defaultValue={magicFieldsValue}
              renderInput={(params) => {
                const { inputProps, InputProps, ...otherParams } = params;
                inputProps.style = {
                  fontSize: "12px",
                };
                return (
                  <TextField
                    {...otherParams}
                    InputProps={InputProps}
                    inputProps={inputProps}
                    fullWidth
                  />
                );
              }}
            />
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "flex-start",
              gap: "0.75rem",
            }}
          >
            {magicFieldsValue?.map((magicField) => {
              const magicAssociateValues = magicField.magic20_associates.filter(
                (el) => magicValues[magicField.id].includes(el.id)
              );

              return (
                <Grid container>
                  <Grid item xs={4}>
                    <Typography
                      variant="subtitle2"
                      style={{
                        fontSize: "12px",
                        fontWeight: "bold",
                        marginBottom: "0.75rem",
                      }}
                    >
                      {magicField.value}
                    </Typography>
                  </Grid>
                  <Grid item xs={8}>
                    <Autocomplete
                      multiple
                      placeholder={"Please select " + magicField.value}
                      ListboxProps={{
                        style: {
                          fontSize: "12px",
                        },
                      }}
                      ChipProps={{
                        style: {
                          fontSize: "12px",
                        },
                      }}
                      getOptionLabel={(option) => option?.value}
                      onChange={(event, newValue) => {
                        if (newValue[newValue.length - 1].id === "add_new") {
                          handleAddNew(
                            event,
                            "magicAssociates",
                            magicField.magic20_field_id
                          );
                        } else {
                          setMagicValues((prev) => {
                            return {
                              ...prev,
                              [magicField.id]: newValue.map((el) => el.id),
                            };
                          });
                        }
                      }}
                      options={[
                        ...(magicField.magic20_associates || []),
                        { id: "add_new", value: "+ Add New" },
                      ]}
                      value={magicAssociateValues}
                      defaultValue={magicAssociateValues}
                      style={{ width: "100%" }}
                      renderInput={(params) => {
                        const { inputProps, InputProps, ...otherParams } =
                          params;
                        inputProps.style = {
                          fontSize: "12px",
                        };
                        return (
                          <TextField
                            {...otherParams}
                            InputProps={InputProps}
                            inputProps={inputProps}
                            fullWidth
                          />
                        );
                      }}
                    />
                  </Grid>
                </Grid>
              );
            })}
          </div>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
            marginTop: "0.5rem",
            marginBottom: "1rem",
            width: "100%",
          }}
        >
          <Button
            variant="contained"
            color="primary"
            style={{ textTransform: "none" }}
            onClick={handleSubmit}
          >
            Submit
          </Button>
        </div>
      </div>
      {showAddNewModal && (
        <AddToListModal
          setShowModal={(par) =>
            setShowAddNewModal((prev) => {
              return { ...prev, show: par };
            })
          }
          postData={showAddNewModal.params}
          type={"organization"}
          handleAddNewValue={handleAddNewValue}
          orgParams={{ organisation_id: cell.row.original.id }}
        />
      )}
    </>
  );
};
export default MagicFieldsComponent;
